import { useParams } from 'react-router-dom';
import { useGetInvoice } from '../../api';
import { AnimatedLoader, Error } from '../../components';
import { useTranslation } from 'react-i18next';
import ResursCheckout from '../../flows/ResursCheckout';
import InvoierCheckout from '../../flows/InvoierCheckout';
import CheckoutNotAvailable from '../../flows/CheckoutNotAvailable';
import { checkoutFlow } from '../../functions/checkoutFlow';

const Checkout = () => {
    const { invoice_id } = useParams();
    const { invoice, fetchedInvoice } = useGetInvoice(invoice_id);
    const { t } = useTranslation();

    if (!fetchedInvoice) {
        return <AnimatedLoader />;
    }

    if (!invoice) {
        return <Error message={t('somethingWentWrong')} />;
    }

    const flow = checkoutFlow(invoice);

    if (flow === 'resurs') {
        return <ResursCheckout invoice={invoice} />;
    }

    // Standard invoices and the Invoier, Two and Stripe financiers share the
    // Invoier customer UX: approve on this page, with or without BankID. See the
    // CHECKOUT_UNIFICATION_PLAN for the longer-term capability-driven approach.
    if (flow === 'invoier') {
        return <InvoierCheckout invoice={invoice} />;
    }

    return <CheckoutNotAvailable invoice={invoice} />;
};

export default Checkout;
